var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('v-text-field',{attrs:{"single-line":"","label":_vm.resourcedef.type,"suffix":"seconds","rules":[(v) => !v || _vm.isValidTimestamp(v) || 'Invalid timestamp'],"hint":"Timestamp in seconds","clearable":""},model:{value:(_vm.dateValue),callback:function ($$v) {_vm.dateValue=$$v},expression:"dateValue"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }